<template>
  <div class="vx-row">
    <div class="vx-col sm:w-2/3 content-wrapper">
      <div class="flex mb-4">
        <div class="lg:w-full w-full bg-grid-color h-12">
          <vs-card class="px-5 py-5">
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Title</span>
                <div style="font-size:0.75rem; color:#aaa;"></div>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-input v-validate="'required'" name="promotitle" class="w-full" v-model="form.promotitle"
                  :maxlength="200" />
                <span class="text-danger text-sm" v-show="errors.has('promotitle')">
                  {{ splitError(errors.first('promotitle'), 'promotitle') }}
                </span>
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Short Title</span>
                <div style="font-size:0.75rem; color:#aaa;">Shown instead of Title where space is limited</div>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-textarea v-validate="'required'" name="promoshortname" class="w-full" v-model="form.promoshortname"
                  :maxlength="200" />
                <span class="text-danger text-sm" v-show="errors.has('promoshortname')">
                  {{ splitError(errors.first('promoshortname'), 'promoshortname') }}
                </span>
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Description</span>
                <div style="font-size:0.75rem; color:#aaa;"></div>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-textarea class="w-full" v-model="form.promodesc" :maxlength="200" />
              </div>
            </div>



            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <!-- <vx-tooltip text="Number of times this can be used" class="" position="top">
                  <span>Quantity</span>
                  <i class="ml-2 fa fa-question-circle" aria-hidden="true"></i>
                </vx-tooltip> -->
                <span>Quantity</span>
                <div style="font-size:0.75rem; color:#aaa;">Number of times this can be used</div>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <div class="vx-row mb-6 vx-align-center">
                  <div class="vx-col" style="display:inline-block; padding-top:15px;">
                    <vs-radio v-model="isPromoLimited" vs-name="quantity" :vs-value="false">Unlimited</vs-radio>
                  </div>
                  <div class="vx-col" style="display:inline-block; padding-top:15px;">
                    <vs-radio v-model="isPromoLimited" vs-name="quantity" :vs-value="true">Limit usage</vs-radio>

                  </div>
                  <div class="vx-col">
                    <vs-input v-validate="{
                      required: isPromoLimited,
                      min_value: 1
                    }" v-on:blur="validateQuantity()" name="qty" id="qty" ref="qty" class="w-full" v-model="form.qty" :disabled="!isPromoLimited" onkeypress="return /^[0-9]/i.test(event.key)"
                      onpaste="return false" />
                    <span class="text-danger text-sm" v-show="errors.has('qty')">
                      {{ splitError(errors.first("qty"), 'qty') }}
                    </span>
                  </div>
                  <div class="vx-col" style="display:inline-block; padding-top:15px;">
                    times
                  </div>
                </div>

              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Discount</span>
                <div style="font-size:0.75rem; color:#aaa;"></div>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <div class="vx-row mb-6">
                  <div class="vx-col">
                    <vs-input v-if="form.disctype === 'percent'"
                      v-validate="{ required: true, max_value: 100, min_value: 0.01 }" name="discvalue"
                      v-model="form.discvalue" style="width:120px;"
                      onkeypress="return /^[0-9]*\.?[0-9]*$/i.test(event.key)" onpaste="return false" />
                    <vs-input v-if="form.disctype === 'amount'" v-validate="{ required: true, min_value: 1 }"
                      name="discvalueamount" v-model="form.discvalue" style="width:120px;"
                      onkeypress="return /^[0-9]*\.?[0-9]*$/i.test(event.key)" />
                    <span class="text-danger text-sm" v-show="errors.has('discvalue')">
                      {{ splitError(errors.first('discvalue'), 'discvalue') }}
                    </span>
                    <span class="text-danger text-sm" v-show="errors.has('discvalueamount')">
                      {{ splitError(errors.first('discvalueamount'), 'discvalueamount') }}
                    </span>
                  </div>

                  <div class="vx-col sm:w-2/3">
                    <ul style="display:inline-block; padding-top:15px;">
                      <li style="display:inline-block">
                        <vs-radio v-model="form.disctype" vs-value="percent" class="mx-3">Percent (%)</vs-radio>
                      </li>
                      <li style="display:inline-block">
                        <vs-radio v-model="form.disctype" vs-value="amount" class="mx-3">
                          {{ currency }}
                        </vs-radio>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Discount from</span>
                <div style="font-size:0.75rem; color:#aaa;"></div>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <ul style="display:inline-block;">
                  <li style="display:inline-block">
                    <vs-radio
                      v-model="form.discfrom"
                      vs-value="fullprice"
                      class="mr-3"
                      >Full Price</vs-radio
                    >
                  </li>
                  <li style="display:inline-block">
                    <vs-radio
                      v-model="form.discfrom"
                      vs-value="currentprice"
                      class="mx-3"
                      >Current Price</vs-radio
                    >
                  </li>
                </ul>
              </div>
            </div>
            <section>
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                  <span>Discount On</span>
                  <div style="font-size:0.75rem; color:#aaa;"></div>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  <ul class="demo-alignment">
                    <li>
                      <vs-radio vs-name="disclevel" v-model="disclevel" vs-value="1">All Tickets</vs-radio>
                    </li>
                    <li>
                      <vs-radio vs-name="disclevel" v-model="disclevel" vs-value="2">Selective Tickets</vs-radio>
                    </li>
                  </ul>
                </div>
              </div>

              <div v-if="disclevel == '2'" class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                  Select the tickets the discount is applicable to
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  <ul class="centerx">
                    <li v-for="(item, i) in productList" :key="i" style="margin:12px 0;">
                      <vs-checkbox v-model="item.selected">
                        <div>{{
                          item.pro_name
                        }}</div>
                        <div style="font-size: 0.75rem; color:#aaa;">{{ item.pro_shortdesc }}</div>
                      </vs-checkbox>
                    </li>
                  </ul>
                  <vs-button v-if="!hideSeemore && totalTicket > 10" type="flat" class="mr-3 mb-2 p-1" @click="seeAllTicket">
                    See more
                  </vs-button>
                </div>
              </div>
            </section>

            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Period</span>
                <div style="font-size:0.75rem; color:#aaa;"></div>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <!-- <flat-pickr
                :config="configdateTimePicker"
                v-model="form.date_start"
                placeholder="Date Time Start"
              />
              <span class="mx-4">to</span>
              <flat-pickr
                :config="configdateTimePicker"
                v-model="form.date_end"
                placeholder="Date Time End"
              /> -->
                <flat-pickr :config="configs.start" v-model="form.date_start" @on-change="onStartChange"
                  placeholder="Date Time Start" />
                <span class="mx-4">to</span>
                <flat-pickr :config="configs.end" v-model="form.date_end" @on-change="onEndChange"
                  placeholder="Date Time End" />
              </div>
            </div>

            <!-- <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span>Quantity</span>
              <div style="font-size:0.75rem; color:#aaa;">
                Number of times this can be used
              </div>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <vs-input
                v-validate="{
                  required: true
                }"
                name="qty"
                class="w-full"
                v-model="form.qty"
              />
            </div>
          </div> -->

            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Note attached to order (Internal use)</span>
                <div style="font-size:0.75rem; color:#aaa;">Internal use</div>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-textarea class="w-full" v-model="form.promonote" />
                <!-- <span
                class="text-danger text-sm"
                v-show="errors.has('promonote')"
              >
                {{ splitError(errors.first('promonote'), 'promonote') }}
              </span> -->
              </div>
            </div>

            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Status</span>
                <div style="font-size:0.75rem; color:#aaa;"></div>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <ul class="demo-alignment">
                  <li>
                    <vs-radio vs-name="promo_status" v-model="form.promo_status" vs-value="1">Enabled</vs-radio>
                  </li>
                  <li>
                    <vs-radio vs-name="promo_status" v-model="form.promo_status" vs-value="0">Disabled</vs-radio>
                  </li>
                </ul>
              </div>
            </div>

            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Weight</span>
                <div style="font-size:0.75rem; color:#aaa;"></div>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-input v-validate="{}" name="weight" class="w-full" v-model="form.weight"
                  onkeypress="return /^[0-9]/i.test(event.key)" onpaste="return false" />
                <span class="text-danger text-sm" v-show="errors.has('weight')">
                  {{ splitError(errors.first('weight'), 'weight') }}
                </span>
              </div>
            </div>

            <div v-if="showInSpecial" class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Token</span>
                <div style="font-size:0.75rem; color:#aaa;"></div>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <ul class="demo-alignment">
                  <li>
                    <vs-radio vs-name="token_type" v-model="form.token_type" vs-value="1">Specify</vs-radio>
                  </li>
                  <li>
                    <vs-radio vs-name="token_type" v-model="form.token_type" vs-value="0">Auto Generate</vs-radio>
                  </li>
                </ul>
              </div>
            </div>

            <div class="vx-row mb-6" v-if="form.token_type == 1">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Your Token</span>
                <div style="font-size:0.75rem; color:#aaa;">
                  Charactors and Numbers Only
                </div>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-input v-validate="'required'" name="token" class="w-full" v-model="form.token" />
              </div>
            </div>

            <!-- <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span>Weight</span>
              <div style="font-size:0.75rem; color:#aaa;"></div>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <vs-input
                v-validate="{}"
                name="weight"
                class="w-full"
                v-model="form.weight"
              />
              <span class="text-danger text-sm" v-show="errors.has('weight')">{{
                errors.first("weight")
              }}</span>
            </div>
          </div> -->

            <div style="height:30px;"></div>
            <div class="vx-row pt-2 mt-0">
              <div class="vx-col w-full ml-auto">
                <vs-button class="mr-3 mb-2" @click="validateForm">Save
                </vs-button>

                <vs-button class="mr-3 mb-2" type="border" @click="cancel()">Cancel
                </vs-button>
              </div>
            </div>
          </vs-card>
        </div>
      </div>
    </div>
    <div class="vx-col sm:w-1/3 pl-4 content-wrapper" >
      <div class="con-vs-card px-5 py-5">
        <div style="display:flex;justify-content:space-between;">
          <div>
            <div>0 used</div>
          </div>
          <div>
            <div v-if="isPromoLimited">{{ parseInt(form.qty) || '' }}</div>
            <div v-else>Unlimited</div>
          </div>
        </div>

        <div>
          <vs-progress :percent="0"
            color="primary"></vs-progress>
        </div>
        <div v-if="isPromoLimited && !isNaN(parseInt(form.qty))" style="font-size: 0.75rem; color: #626262">
          {{ parseInt(form.qty) }} remaining
        </div>

      </div>
      <div class="con-vs-card mt-5 px-5 py-5">
        <div >
          <div>
            <div style="font-size: 0.75rem; color: #626262">Preview</div>
          </div>
          <div style="font-size: 1.25rem; color: #000" class="mt-2">
            Special Link
          </div>
          <div style="font-size: 2rem; color: #000">
            {{form.promotitle}}
          </div>
          <div>
            {{form.promoshortname}}
          </div>
        </div>

      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import { mapState } from "vuex";

import Service from "@/services";
import { timezones } from "@/utils/Timezones";

import VxAutoSuggest from "@/components/vx-auto-suggest/VxAutoSuggest.vue";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

export default {
  components: {
    VxAutoSuggest,
    flatPickr
  },
  props: ["promocode_id"],
  computed: {
    ...mapState({
      accessToken: state => {
        return state.Auth.accessToken;
      },
      s: state => {
        return state.Utility.s;
      },
      e: state => {
        return state.Utility.e;
      }
    })
  },
  data() {
    return {
      productList: [],
      isPromoLimited: false,
      form: {
        e: null,
        promotitle: null,
        promoshortname: null,
        promo_type: "link",
        promodesc: null,
        disctype: "percent",
        discvalue: null,
        discfrom: "fullprice",
        // disclevel: 1,
        date_start: null,
        date_end: null,
        pccode: null,
        promonote: null,
        promo_status: 1,
        selective: [],
        token_type: 0,
        token: null,
        weight: null
      },
      disclevel: '1',
      configdateTimePicker: {
        enableTime: true,
        dateFormat: "d-m-Y H:i"
      },
      showInSpecial: false,
      currency: 'THB',
      configs: {
        basic: {},
        start: {
          minDate: null,
          maxDate: null,
          enableTime: true,
          dateFormat: 'Y-m-d H:i'
        },
        end: {
          minDate: null,
          enableTime: true,
          dateFormat: 'Y-m-d H:i'
        },
      },
      totalTicket: 0,
      per_page: 10,
      hideSeemore: false
    };
  },
  watch: {
    "form.pccode": function (newVal, oldVal) {
      this.form.pccode = newVal.toUpperCase();
    },
    isPromoLimited: function() {
      if(!this.isPromoLimited) {
        // this.form.qty = ''
      }else {
        setTimeout(()=>{
          document.getElementById('qty').focus()
        },300)
      }
    }
  },
  created() {
    this.form.e = this.e;

    let data = {
      e: this.e
    };

    let params = Object.keys(data)
      .map(key => key + "=" + data[key])
      .join("&");

    const paramsData = params + `&perPage=${this.per_page}`
    Service.Product.gets(paramsData).then(res => {
      this.totalTicket = res.data.total
      if (res.data.total > this.per_page) {
        this.hideSeemore = false;
      } else {
        this.hideSeemore = true;
      }
      this.productList = res.data.rows.map(item => {
        return {
          product_id: item.product_id,
          pro_name: item.pro_name,
          pro_shortdesc: item.pro_shortdesc,
          selected: false
        };
      });
    });
  },
  methods: {
    validateQuantity() {
      /* free event, max = 100 */
      this.$validator.validate('qty').then(result => {
        console.log('result', result)
        if (result) {
          // if form have no errors
          // this.submit();
        }
      });
      return;
    },
    splitError(val, word) {
      if (!val) {
        return
      }
      else {
        const data = val.split(word)
        return data[0] + data[1]
      }
    },
    validateForm() {
      this.$validator.validateAll().then(result => {
        if (result) {
          if(!this.isPromoLimited) {
            this.form.qty = ''
          }
          this.submit();
        }
      });
    },
    cancel() {
      const path = this.$route.path === '/special-links/add-promo'
      this.$router.push(`/${path ? 'promotions' : 'special-links'}?s=` + this.s + "&e=" + this.e);
    },
    submit() {
      this.form.e = this.e;
      this.form.selective = this.productList.filter(x => x.selected == true);

      if (this.form.token == "") {
        this.form.token = null;
      }

      // this.$vs.loading();
      const path = this.$route.path === '/special-links/add-promo'
      this.form = {
        ...this.form,
        promo_type: path ? 'std' : 'link'
      };

      Service.Bootsale.addPromo(this.form)
        .then(res => {
          if (res.success) {
            this.$vs.notify({
              position: 'top-right',
              title: "Success",
              text: "Add new promotion completed.",
              color: "success"
            });
            this.$router.push(`/${path ? 'promotions' : 'special-links'}?s=` + this.s + "&e=" + this.e);
          }
          this.$vs.loading.close();
        })
        .catch(error => {
          this.$vs.notify({
            position: 'top-right',
            title: "Oops!",
            text: "ERROR : " + error.data,
            color: "danger"
          });
          this.$vs.loading.close();
        });
    },
    getcurrency() {
      let data = {
        e: this.$route.query.e,
        s: this.$route.query.s
      };
      Service.Event.get(data.e)
        .then(res => {
          this.currency = res.data.event.currency
        })
        .catch(() => { })
    },
    onEndChange(selectedDates, dateStr, instance) {
      this.configs.start.maxDate = dateStr
    },
    onStartChange(selectedDates, dateStr, instance) {
      this.configs.end.minDate = dateStr
    },
    seeAllTicket() {
      let data = {
        e: this.e
      };
      let params = Object.keys(data)
        .map(key => key + "=" + data[key])
        .join("&");

      const selectedid = this.productList.filter(item => item.selected).map(item => item.product_id)
      const paramsData = params + `&perPage=${this.totalTicket}`
      Service.Product.gets(paramsData).then(res => {
        this.productList = res.data.rows.map(item => {
          return { ...item, selected: selectedid.includes(item.product_id) };
        });
        this.hideSeemore = true

      })
    }

  },
  mounted() {
    const promotion = this.$route.path === '/special-links/add-promo'
    this.getcurrency();
    if (!promotion) {
      this.showInSpecial = true
    }
  }
};
</script>
